/* Aromahain — "In den Warenkorb" per le card custom (form.ah-add-form).
   Usa lo stesso contratto eventi del tema Horizon (CartLinesUpdateEvent): il carrello a tendina
   si apre, si aggiorna (sezioni) e il contatore nell'header cambia senza ricaricare la pagina. */
import { CartLinesUpdateEvent } from '@shopify/events';

const ADD_URL = (window.Theme && Theme.routes && Theme.routes.cart_add_url) || '/cart/add.js';
const CART_URL = ((window.Theme && Theme.routes && Theme.routes.cart_url) || '/cart') + '.js';

async function addToCart(form) {
  const button = form.querySelector('button[type="submit"]');
  const label = button ? button.textContent : '';
  if (button) button.disabled = true;

  const formData = new FormData(form);
  const sectionIds = [...document.querySelectorAll('cart-items-component')]
    .map((el) => el.dataset.sectionId)
    .filter(Boolean);
  if (sectionIds.length) formData.append('sections', sectionIds.join(','));
  const quantity = Number(formData.get('quantity')) || 1;

  const deferred = CartLinesUpdateEvent.createPromise();
  form.dispatchEvent(
    new CartLinesUpdateEvent({
      action: 'add',
      context: 'product',
      lines: [{ merchandiseId: String(formData.get('id')), quantity }],
      promise: deferred.promise,
    })
  );

  try {
    const response = await fetch(ADD_URL, {
      method: 'POST',
      body: formData,
      headers: { Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
    }).then((r) => r.json());
    const cart = await fetch(CART_URL, { headers: { Accept: 'application/json' } }).then((r) => r.json());
    const failed = Boolean(response && response.status);

    deferred.resolve({
      cart: CartLinesUpdateEvent.createCartFromAjaxResponse(cart),
      detail: {
        items: cart.items,
        source: 'aromahain-card',
        itemCount: quantity,
        sections: failed ? undefined : response.sections,
        didError: failed,
      },
    });

    if (button) {
      button.disabled = false;
      if (failed) {
        button.textContent = response.description || button.dataset.na || 'Nicht verfügbar';
      } else {
        button.textContent = button.dataset.done || '✓ Im Warenkorb';
        button.classList.add('is-done');
      }
      setTimeout(() => {
        button.textContent = label;
        button.classList.remove('is-done');
      }, 2500);
    }
  } catch (error) {
    deferred.reject(error);
    form.submit();
  }
}

document.addEventListener('submit', (event) => {
  const form = event.target;
  if (!(form instanceof HTMLFormElement) || !form.classList.contains('ah-add-form')) return;
  event.preventDefault();
  addToCart(form);
});
window.__ahCartModule = true;
